<template>
	<div class="container">
		<div class="case">
			<div class="case-img"></div>
			<div class="case-body">
				<div class="case-body-list" v-for="(s,i) in 6" :key="i">
					<div class="case-body-list-item" v-for="(item,key) in 4" :key="key">
						<img :src="`../../../static/case/Brand${(i * 4 + key + 1) < 10 ? `0`+(i * 4 + 1 + key ) : (i * 4 + 1 + key )}.png`" alt="合作商">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'EnterpriseCase',
		methods: {
			
		}
	}
</script>

<style scoped="scoped">
	@import url("./enterprise-case.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-case/enterprise-case.vue